import * as React from 'react';
import type { FieldError } from 'react-hook-form';
import { Label } from '@components/ui/label';
import { Input } from '@components/ui/input';
import { cn } from '@lib/utils';

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: FieldError;
  id: string;
  required?: boolean;
}

export const FormField = React.forwardRef<HTMLInputElement, FormFieldProps>(
  ({ label, error, id, required, className, ...props }, ref) => {
    const errorId = `${id}-error`;
    return (
      <div className={cn('flex flex-col gap-1.5', className)}>
        <Label htmlFor={id}>
          {label}
          {required && (
            <span className="ml-1 text-destructive" aria-hidden="true">
              *
            </span>
          )}
        </Label>
        <Input
          ref={ref}
          id={id}
          aria-required={required}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          {...props}
        />
        {error && (
          <p id={errorId} role="alert" className="text-xs text-destructive">
            {error.message}
          </p>
        )}
      </div>
    );
  },
);
FormField.displayName = 'FormField';
